import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SUPPORTED_LANGUAGES, LanguageCode } from "@/lib/languages";

interface LanguageSelectorProps {
  value: LanguageCode;
  onChange: (value: LanguageCode) => void;
  className?: string;
}

export const LanguageSelector = ({ value, onChange, className }: LanguageSelectorProps) => {
  return (
    <div className={className}>
      <Select value={value} onValueChange={(v) => onChange(v as LanguageCode)}>
        <SelectTrigger className="h-12 w-full rounded-[13px] border-[1.5px] border-[#e6edf1] bg-white px-[15px] text-base font-medium text-[#0f1720] shadow-none focus:ring-[#24a89a]">
          <div className="flex items-center gap-2 truncate">
            <Globe className="h-4 w-4 shrink-0 text-[#64748b]" />
            <SelectValue placeholder="Select language" />
          </div>
        </SelectTrigger>
        <SelectContent className="z-50 max-h-[300px] bg-background">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
